import React, {Component} from 'react';
import { connect } from 'dva';
import { Button, Row, Col } from 'antd';
import _ from 'lodash';

const NOC = 72;

class CounsellingItem extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(item){
    const {dispatch} = this.props;

    dispatch({
      type:'school/selectedItem',
      item: item
    });
  }

  render() {
    const {item, type, index} = this.props;
    const gender = (item.get('gender') === 'male') ? 'is-mr' : 'is-ms';
    const highlight = (index === 0)?'highlight':'';

    return (
      <section className={`${gender} counselling-${type} ${highlight}`}>
        <div className={`counselling-${type}__title`}>
          {item.get('title')}
        </div>
        <div className="counselling-item__school">
          <Row type="flex" justify="space-around" align="middle" gutter={8}>
            <Col span={4}>
              <img className={`counselling-${type}__img`} src={item.get('school_logo')} alt={item.get('school')}/>
            </Col>
            <Col span={20}>
              <div className={`counselling-${type}__school_name`}>{item.get('school')} <span>({item.get('school_type')})</span></div>
              <div className={`counselling-${type}__school_course`}>{item.get('course')}</div>
            </Col>
          </Row>
        </div>
        <div>
          {item.get('acquired_visa') &&
          <div className={`counselling-${type}__status mb-1`}>
          <i className="fa fa-calendar"></i> 延長期間: <span className={`counselling-${type}__status_meta`}>{item.get('term')}<span>ヶ月</span></span>
            {item.get('extend_visa') &&
            <span>トラトラで更新</span>
            }
          </div>
          }
          <div className={`counselling-${type}__status mb-1`}>
            <i className="fa fa-dollar"></i> 更新時の費用: <span className={`counselling-${type}__status_meta`}><span>$</span>{item.get('cost')}</span>
            {item.get('split_payment') &&
            <span>
              分割 <span>$</span>{item.get('split_cost')}
            </span>
            }
          </div>
        </div>

        <div>
          <div className={`counselling-${type}__desc`}
               dangerouslySetInnerHTML={{__html: _.truncate(item.get('desc'),{length:NOC, separator:' '})}}></div>
        </div>

        <div>
          <Button className='btn btn-xs btn-outline-primary mr-2' onClick={e => this.handleClick(item)}>詳しく読む</Button>
          <Button className='btn btn-xs btn-primary' href={`/school/${item.get('school_type')}/${item.get('school_key')}`}>この学校の詳細を見る</Button>
        </div>
      </section>
    );
  }
}

export default connect(({ meta, school }) => ({
  meta, school
}))(CounsellingItem);



// WEBPACK FOOTER //
// ./src/pages/school/components/CounsellingItem.js